import { Desktop } from '@99designs/common/components/Desktop';
import { Mobile } from '@99designs/common/components/Mobile';
import { breakpoints } from '@99designs/common/core/settings';
import { DesignerCard_User } from '__generated__/DesignerCard_User';
import { DesignerSource } from '__generated__/types';
import AddDesignerButton from 'projects/components/AddDesignerButton';
import React, { useContext, useEffect, useState } from 'react';
import MediaQuery from 'react-responsive';
import styled from 'styled-components';
import BriefContext from './BriefContext';
import Card from './Card';
import DesignCarousel from './DesignCarousel';
import DesignerCardContext from './DesignerCardContext';
import DesignerMeta from './DesignerMeta';
import FileOverlay from './FileOverlay';

const DesignerDetails = styled.div`
    min-height: 201px;
`;

export interface Props {
    user: DesignerCard_User;
    isSelected: boolean;
    onMount: () => void;
    designerSource: DesignerSource;
    position: number;
}

export default function DesignerCard(props: Props) {
    const { user, isSelected, onMount, position, designerSource } = props;

    useEffect(() => {
        onMount();
    }, []);

    const [isOverlayActive, updateIsOverlayActive] = useState(false);
    const [showFullBiography, updateShowFullBiography] = useState(false);
    const [activeDesign, updateActiveDesign] = useState(0);
    const { brief, themeName, totalAllowableDesigners } = useContext(BriefContext);
    const { highlightNewDesigners, stats, selectDesignerLabels } = useContext(DesignerCardContext);
    const theme = themeName ? themeName : '';

    const cardVariations = ['designer-card', theme];
    return (
        <Card variations={isSelected ? [...cardVariations, 'selected'] : cardVariations}>
            <Card.Media>
                <MediaQuery minWidth={breakpoints.normal[0]}>
                    {matches => (
                        <DesignCarousel
                            designer={user}
                            isClickable={matches}
                            showPaginators={false}
                            onClick={() => {
                                updateIsOverlayActive(true);
                            }}
                            onChange={designIndex => {
                                updateActiveDesign(designIndex);
                            }}
                            selectedIndex={activeDesign}
                        />
                    )}
                </MediaQuery>
                {isOverlayActive && (
                    <FileOverlay
                        designer={user}
                        selectedDesignIndex={activeDesign}
                        onClose={() => updateIsOverlayActive(false)}
                        onDesignChange={designIndex => {
                            updateActiveDesign(designIndex);
                        }}
                    />
                )}
            </Card.Media>
            <DesignerDetails>
                <Card.Block>
                    <Desktop>
                        <DesignerMeta
                            designer={user}
                            onClickDescription={() => {
                                updateIsOverlayActive(true);
                            }}
                            highlightNewDesigners={highlightNewDesigners}
                            stats={stats}
                        />
                    </Desktop>
                    <Mobile>
                        <DesignerMeta
                            designer={user}
                            onClickDescription={() => {
                                updateShowFullBiography(!showFullBiography);
                            }}
                            showFullBiography={showFullBiography}
                            highlightNewDesigners={highlightNewDesigners}
                            stats={stats}
                        />
                    </Mobile>
                </Card.Block>
            </DesignerDetails>
            <Card.Block>
                <AddDesignerButton
                    designer={user}
                    position={position}
                    designerSource={designerSource}
                    selectDesignerLabels={selectDesignerLabels}
                    brief={brief}
                    totalAllowableDesigners={totalAllowableDesigners}
                />
            </Card.Block>
        </Card>
    );
}
